import { motion, useReducedMotion } from "framer-motion";

export const PageShell = ({ children }) => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.main
      initial={reduceMotion ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={reduceMotion ? undefined : { opacity: 0, y: -10 }}
      transition={{ duration: reduceMotion ? 0 : 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.main>
  );
};

export const PageHero = ({ overline, title, description }) => {
  const reduceMotion = useReducedMotion();
  const initial = reduceMotion ? false : { opacity: 0, y: 16 };
  const transition = { duration: reduceMotion ? 0 : 0.45, ease: [0.22, 1, 0.36, 1] };

  return (
    <section className="page-hero relative overflow-hidden">
      <div className="hero-glow pointer-events-none absolute inset-0" />
      <div className="page-hero-grid bg-grid pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 pb-20 pt-36 sm:px-6 lg:px-8 lg:pb-28 lg:pt-44">
        <motion.p
          initial={initial}
          animate={{ opacity: 1, y: 0 }}
          transition={transition}
          className="page-hero-overline flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em]"
        >
          <span className="spark-rule inline-block h-px w-8" aria-hidden="true" />
          {overline}
        </motion.p>
        <span className="mt-6 block overflow-hidden pb-1">
        <motion.h1
          initial={reduceMotion ? false : { y: "105%" }}
          animate={{ y: 0 }}
          transition={{ ...transition, delay: reduceMotion ? 0 : 0.08 }}
          className="page-hero-title font-display text-4xl font-bold tracking-tight leading-[1.08] sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
      </span>
      {description && (
        <motion.p
          initial={initial}
          animate={{ opacity: 1, y: 0 }}
          transition={{ ...transition, delay: reduceMotion ? 0 : 0.16 }}
          className="page-hero-description mt-6 max-w-2xl text-base leading-relaxed sm:text-lg"
        >
          {description}
        </motion.p>
      )}
      </div>
    </section>
  );
};
